<template>
  <th :width="width" :class="[classes, outerClasses]" @click="headerClick">
    <slot
      name="header"
      :header="header"
      :header-label="headerLabel"
      :header-index="headerIndex"
      :sort-by="sortBy"
      :sort-direction="sortDirection"
    >
      <SfTableHeaderCell
        :header-id="headerId"
        :header-index="headerIndex"
        :max-header-cell-width="maxHeaderCellWidth"
        :sort-direction="sortDirection"
        :sort-by="sortBy"
        :sortable="!nonSortableHeaders.includes(header)"
      >
        {{ headerLabel }}
      </SfTableHeaderCell>
    </slot>
  </th>
</template>
<script setup lang="ts" generic="HD extends BaseHeader">
import type { BaseHeader } from './types'
import type { TableSortDirections, TableVariants } from './constants'
import { tableVariants } from './constants'

import { computed } from 'vue'
import SfTableHeaderCell from './sf-table-header-cell.vue'
import { useCellStyles } from './use-cell-styles'

interface Props {
  header: HD
  headerIndex: number
  hidden?: boolean
  maxHeaderCellWidth?: number | null
  nonSortableHeaders?: HD[]
  sortDirection: TableSortDirections
  sortBy?: HD | ''
  variant?: TableVariants
}

const {
  header,
  hidden,
  maxHeaderCellWidth = null,
  nonSortableHeaders = [],
  sortBy = '',
  variant = tableVariants.DEFAULT,
} = defineProps<Props>()

const emit =
  defineEmits<{
    headerClick: [headerId: string]
  }>()

const { classes: outerClasses } = useCellStyles(() => variant)

const classes = computed(() => {
  return {
    'sf-pointer': !hidden,
    'sf-table-header__th--hidden': hidden,
  }
})

const headerLabel = computed(() => {
  if (typeof header === 'string') {
    return header
  }

  return header.label || header.id
})

const headerId = computed(() => {
  if (typeof header === 'string') {
    return header
  }

  return header.id
})

const width = computed(() => {
  if (typeof header === 'string') {
    return ''
  }

  return header.width || ''
})

const headerClick = () => {
  emit('headerClick', headerId.value)
}
</script>

<style lang="scss" scoped>
.sf-table-header {
  &__th {
    &--hidden {
      position: absolute;
      width: 1px;
      height: 1px;
      margin: -1px;
      border: 0;
      padding: 0;
      clip: rect(0 0 0 0);
      overflow: hidden;
    }
  }
}
</style>
